// extracted by mini-css-extract-plugin
export default {"wrap":"MessagesPage_wrap__ZoQD9","menuBlock":"MessagesPage_menuBlock__drK1Q","outletBlock":"MessagesPage_outletBlock__r-kYo"};